// Shared by Login.jsx and VerifyOtp.jsx — both call AuthContext.login() (which
// populates localStorage.allowedPages) and then need to land on the user's
// first allowed page.
const PAGE_PATHS = {
  dashboard:                 '/home',
  user_management:           '/user-management',
  access_panel:              '/access-panel',
  master_qualifications:     '/master/qualifications',
  master_sub_qualifications: '/master/sub-qualifications',
  master_equipment:          '/master/equipment',
  master_certifications:     '/master/certifications',
  view_user:                 '/home',
  user_form:                 '/home',
  edit_user:                 '/home',
};

export const getPostLoginPath = () => {
  const stored = localStorage.getItem("allowedPages");
  const pages  = stored ? JSON.parse(stored) : [];
  return pages.length > 0 ? (PAGE_PATHS[pages[0]] || '/home') : '/home';
};
